import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectDbnpMappingListItems } from "../../../../../../redux/dbnp-mappings/selector";
import { dbnpMappings } from "../../../../../../redux/dbnp-mappings/action";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";

const ManagementDbnpMappings = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
    const dbnpMappingItems = useSelector(selectDbnpMappingListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'ConsumerDBNPName', headerName: 'Consumer DBNP'  },
          { field: 'ProviderDBNPName', headerName: 'Provider DBNP' },
          { field: 'ISDBNPProviderEnabled', headerName: 'DBNP Provider Enabled', cellRenderer: 'yesNoRenderer' },
          { field: 'IsDBNPConsumerEnabled', headerName: 'DBNP Consumer Enabled', cellRenderer: 'yesNoRenderer' },
          { field: 'IsDBNPPartnerRoleEnabled', headerName: 'DBNP Partner Role Enabled', cellRenderer: 'yesNoRenderer' },
          { field: 'IsDBNPSupplierRoleEnabled', headerName: 'DBNP Supplier Role Enabled', cellRenderer: 'yesNoRenderer' },
          { field: 'IsDBNPVendorRoleEnabled', headerName: 'DBNP Vendor Role Enabled', cellRenderer: 'yesNoRenderer' },
          { field: 'CreatedOnUtc', headerName: 'Created On' , isDateValueFormat:true},
          { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat:true }
      
        ]);
      }
      const fetchDbnpMapping=()=>{

        dispatch(dbnpMappings.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp-mappings/list`,entity:'dbnpMappings',jsonData:{
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
      }}))
       
      }
      const handleDelete=(data: any)=>{
        dispatch(dbnpMappings.delete({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp-mappings/delete`,
          entity: 'dbnpMappings',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
        dispatch(dbnpMappings.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp-mappings/list`,entity:'dbnpMappings',jsonData:{
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
      }}))
      });
      }
      const handleEdit=(data: any)=>{
    
        navigate(`${data?.Id}`)
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
	useEffect(() => {
        createColumnDefs()
        fetchDbnpMapping()
		
	}, [pageData])
  const additionButtons: any = [
    {
      name: 'Add DBNP Mappings',
      callback: () => handleAdd(),
    }
  ];
	return (
     <>
     {dbnpMappingItems?.isLoading ? 
      <PageLoader />
  : 
     <Table columnData={columnDefs} rowData={dbnpMappingItems?.result?.items} setPageData={setPageData} 
     paginationData={dbnpMappingItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="DBNP Mappings" />
}
     </>
		
       
     
	);
};

export default ManagementDbnpMappings;


